import { Sprite } from "./Sprite";
import { FrameAnimation } from "../components/FrameAnimation";
import { HideFlags } from "../Const";
import { ILaya } from "../../ILaya";
import { Event } from "../events/Event";
export class Animation extends Sprite {
    constructor() {
        super();
        this._comp = this.addComponent(FrameAnimation);
        this._comp.hideFlags |= HideFlags.HideAndDontSave;
        this._comp.autoPlay = false;
    }
    get loop() {
        return this._comp.loop;
    }
    set loop(value) {
        this._comp.loop = value;
    }
    get wrapMode() {
        return this._comp.wrapMode;
    }
    set wrapMode(value) {
        this._comp.wrapMode = value;
    }
    get interval() {
        return this._comp.interval;
    }
    set interval(value) {
        this._comp.interval = value;
    }
    get index() {
        return this._comp.frame;
    }
    set index(value) {
        this._comp.frame = value;
    }
    get count() {
        return this._comp.frames.length;
    }
    get source() {
        return this._comp.source;
    }
    set source(value) {
        this._comp.source = value;
    }
    get images() {
        return this._comp.images;
    }
    set images(value) {
        this._comp.images = value;
    }
    get isPlaying() {
        return this._comp.isPlaying;
    }
    set autoPlay(value) {
        this._comp.autoPlay = value;
    }
    get autoPlay() {
        return this._comp.autoPlay;
    }
    play(start, loop, name = "") {
        if (name)
            this._setFramesFromCache(name, true);
        if (start != null)
            this._comp.frame = (typeof (start) == 'string') ? this.getFrameByLabel(start) : start;
        if (loop != null)
            this._comp.loop = loop;
        this._comp.play();
    }
    clear() {
        this._comp.stop();
        this._comp.frames = null;
        this._labels = null;
        return this;
    }
    stop() {
        this._comp.stop();
    }
    gotoAndStop(position) {
        this.index = (typeof (position) == 'string') ? this.getFrameByLabel(position) : position;
        this.stop();
    }
    addLabel(label, index) {
        if (!this._labels) {
            this._labels = [];
            this._comp._labels = this._labels;
        }
        this._labels[index] = label;
    }
    removeLabel(label) {
        if (!this._labels)
            return;
        for (let i = 0, n = this._labels.length; i < n; i++) {
            if (this._labels[i] == label) {
                delete this._labels[i];
            }
        }
    }
    loadImages(urls) {
        this._comp.images = urls;
        return this;
    }
    loadAtlas(url) {
        this._comp.source = url;
        return this;
    }
    getFrameByLabel(label) {
        if (!this._labels)
            return 0;
        let i = this._labels.indexOf(label);
        return i != -1 ? i : 0;
    }
    static createFrames(urls, key) {
        Animation.framesMap[key] = urls;
        ILaya.loader.load(urls);
    }
    static clearCache(key) {
        delete Animation.framesMap[key];
    }
    _setFramesFromCache(name, showWarn = false) {
        let urls = Animation.framesMap[name];
        if (urls) {
            this.images = urls;
            return true;
        }
        else {
            if (showWarn)
                console.log("ani not found:", name);
        }
        return false;
    }
}
Animation.framesMap = {};
